import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Flex',
  props: {
    align: { default: 'start' },
    justify: { default: 'start' },
    direction: { default: 'row' },
    wrap: { default: 'nowrap' },
    gap: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`
      flex
      align--${props.align}
      justify--${props.justify}
      gap--${props.gap}
      direction--${props.direction}
      wrap--${props.wrap}
  `)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})